import apiShowcase from '@/api/showcase'

const state = {
	data: {},
	plyrs: []
}

const getters = {
	data(state) {
		return state.data
	},
	plyrs(state) {
		return state.plyrs
	}
}

const mutations = {
	setData(state, data) {
		state.data = data
	},
	addPlyr(state, plyr) {
		state.plyrs.push(plyr[0])
	}
}

const actions = {
	fetchData({ commit }) {
		apiShowcase.getData(data => commit('setData', data))
	},
	addPlyr({ commit }, plyr) {
		commit('addPlyr', plyr)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
